// extracted by mini-css-extract-plugin
module.exports = {"selectedView":"styles_selectedView__1kNaS","blackButton":"styles_blackButton__GUk9u","ant-btn-primary":"styles_ant-btn-primary__2nT2H","editForm":"styles_editForm___yn96"};